import Swiper from "swiper";
import { Autoplay, Navigation, Pagination, A11y, Keyboard, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

class HomepageCarousel {
  constructor(carousel) {
    this.$carousel = carousel;
    this.setCarousel();
  }

  setCarousel() {
    const el = this.$carousel.querySelector('.swiper') ?? this.$carousel;
    const autoplayDelay = 7000;
    const transitionSpeed = 600;
    const coverEl = this.$carousel.closest('.c-cover');
    const styleTarget = coverEl ?? el;
    styleTarget.style.setProperty('--autoplay-delay', `${autoplayDelay}ms`);
    styleTarget.style.setProperty('--transition-speed', `${transitionSpeed}ms`);
    this.swiper = new Swiper(el, {
      modules: [Autoplay, Navigation, Pagination, A11y, Keyboard, EffectFade],
      speed: transitionSpeed,
      autoplay: {
        delay: autoplayDelay,
        disableOnInteraction: false,
      },
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      direction: "horizontal",
      navigation: {
        nextEl: ".c-cover__next",
        prevEl: ".c-cover__prev",
      },
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      pagination: {
        el: ".c-cover__pagination",
        type: "bullets",
        clickable: true,
      },
      zoom: true,
    });

    this.isPlaying = true;

    const toggleBtn = coverEl
      ? coverEl.querySelector('.js-autoplay-toggle')
      : null;

    if (toggleBtn) {
      toggleBtn.addEventListener('click', () => {
        if (this.isPlaying) {
          this.swiper.autoplay.stop();
          coverEl.classList.add('is-paused');
          toggleBtn.setAttribute('aria-label', 'Play slideshow');
          this.isPlaying = false;
        } else {
          this.swiper.autoplay.start();
          coverEl.classList.remove('is-paused');
          toggleBtn.setAttribute('aria-label', 'Pause slideshow');
          this.isPlaying = true;
        }
      });
    }
  }
}

export default HomepageCarousel;
